import { render } from "./SKUBandingTable.vue?vue&type=template&id=dcd85c7c&scoped=true&ts=true"
import script from "./SKUBandingTable.vue?vue&type=script&lang=ts"
export * from "./SKUBandingTable.vue?vue&type=script&lang=ts"

import "./SKUBandingTable.vue?vue&type=style&index=0&id=dcd85c7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcd85c7c"]])

export default __exports__